import { Typography } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import cx from 'classnames';
import PropTypes from 'prop-types';

import TextLink from 'src/components/TextLink';
import { SUPPORT_URL, URL_PRIVACY_POLICY, URL_TERMS } from 'src/const';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  showContactUs: PropTypes.bool,
  classes: PropTypes.shape(),
};

const defaultProps = {
  className: null,
  showContactUs: false,
  classes: null,
};

const SignUpAgreement = ({ className, classes, showContactUs }) => {
  const styles = useStyles({ classes });

  return (
    <Typography
      className={cx(styles.root, className)}
      variant="body2"
      component="div"
      data-testid="SignUpAgreement"
    >
      By signing up, you agree to the{' '}
      <TextLink
        className={styles.link}
        href={URL_TERMS}
        target="_blank"
        data-testid="SignUpAgreement__TermsLink"
      >
        Terms of Service
      </TextLink>{' '}
      and{' '}
      <TextLink
        className={styles.link}
        href={URL_PRIVACY_POLICY}
        target="_blank"
        data-testid="SignUpAgreement__PrivacyLink"
      >
        Privacy Policy
      </TextLink>
      {showContactUs ? (
        <Link
          target="_blank"
          href={SUPPORT_URL}
          className={styles.contactUsLink}
        >
          Contact us
        </Link>
      ) : (
        <span>.</span>
      )}
    </Typography>
  );
};

SignUpAgreement.propTypes = propTypes;
SignUpAgreement.defaultProps = defaultProps;

export default SignUpAgreement;
